// @flow
import React from 'react';
import classnames from 'classnames';
import IconLabel from '../util/IconLabel';
import styles from './HeroSliderControls.css';
import { commonMessages } from '../messages/Common';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

type OwnProps = {
  onPrevClick: Function,
  onNextClick: Function,
  activeIndex: number,
  itemCount: number,
};

type Props = OwnProps & {
  intl: IntlShape,
};

function HeroSliderControls({ onPrevClick, onNextClick, activeIndex, itemCount, intl }: Props) {
  return (
    <React.Fragment>
      <button
        className={classnames(
          styles.sliderButton,
          styles.prevButton,
          activeIndex === 0 && styles.inactive
        )}
        onClick={onPrevClick}
        aria-label={intl.formatMessage(commonMessages.previous)}
      >
        <IconLabel name="chevron-left" className={styles.icon} size="3rem" />
      </button>
      <button
        className={classnames(
          styles.sliderButton,
          styles.nextButton,
          activeIndex === itemCount - 1 && styles.inactive
        )}
        onClick={onNextClick}
        aria-label={intl.formatMessage(commonMessages.next)}
      >
        <IconLabel name="chevron-right" className={styles.icon} size="3rem" />
      </button>
    </React.Fragment>
  );
}

export default injectIntl(HeroSliderControls);
